import React, { useState } from "react";
import { Box, Container, Typography } from "@mui/material";

export default function EvolutionTimeline({ heading, items }) {
  const [active, setActive] = useState(0);
  const current = items[active];

  return (
    <Box sx={{ py: { xs: 4, md: 6 } }}>
      <Typography
        fontFamily="KIAbodyLatinbasic_Bold"
        textAlign="center"
        sx={{ fontSize: "clamp(24px, 4vw, 34px)", mb: 4, px: 2 }}
      >
        {heading}
      </Typography>

      <Container maxWidth="lg">
        {/* Year tabs */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            borderBottom: "1px solid #e5e5e5",
            mb: 4,
          }}
        >
          {items.map((item, i) => (
            <Box
              key={item.year}
              component="button"
              onClick={() => setActive(i)}
              sx={{
                flex: { xs: 1, sm: "0 0 140px" },
                background: "none",
                border: "none",
                borderBottom: i === active ? "3px solid #BB162B" : "3px solid transparent",
                py: 1.5,
                cursor: "pointer",
                fontFamily: i === active ? "KIAbodyLatinbasic_Bold" : "KIAbodyLatinbasic_Regular",
                fontSize: "clamp(15px, 2vw, 20px)",
                color: i === active ? "#000" : "#888",
                transition: "color 0.3s",
              }}
            >
              {item.year}
            </Box>
          ))}
        </Box>

        <Box
          key={current.year}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            gap: { xs: 3, md: 6 },
            animation: "sorentoFade 0.5s ease",
            "@keyframes sorentoFade": {
              from: { opacity: 0 },
              to: { opacity: 1 },
            },
          }}
        >
          <Box
            component="img"
            src={current.image}
            alt={`Kia Sorento ${current.title}`}
            loading="lazy"
            decoding="async"
            sx={{ width: { xs: "100%", md: "55%" }, height: "auto", objectFit: "contain" }}
          />
          <Box sx={{ width: { xs: "100%", md: "45%" } }}>
            <Typography
              fontFamily="KIAbodyLatinbasic_Bold"
              sx={{ fontSize: "clamp(40px, 6vw, 64px)", color: "#e5e5e5", lineHeight: 1 }}
            >
              {current.year}
            </Typography>
            <Typography
              fontFamily="KIAbodyLatinbasic_Bold"
              sx={{ fontSize: "clamp(20px, 3vw, 28px)", my: 1.5 }}
            >
              {current.title}
            </Typography>
            <Typography
              fontFamily="KIAbodyLatinbasic_Regular"
              color="text.secondary"
              sx={{ fontSize: "clamp(14px, 1.6vw, 16px)", lineHeight: 1.7 }}
            >
              {current.description}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
